import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-12" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Notify")
  ])
], -1)
const _hoisted_5 = { class: "row w-100" }
const _hoisted_6 = { class: "col-md-12 col-lg-12 my-1" }
const _hoisted_7 = { class: "row mt-2 w-100" }
const _hoisted_8 = { class: "col-12 col-sm-8 col-md-8 col-lg-8 col-xl-9 my-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted h6 font-weight-normal mt-2" }, " Insert phone number without symbols (+, -, etc) or spaces ", -1)
const _hoisted_10 = { class: "col-12 col-sm-4 col-md-4 col-lg-4 col-xl-3 mt-2" }
const _hoisted_11 = { class: "d-flex flex-row" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = {
  key: 1,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Call ")
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = {
  key: 1,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" SMS ")

import { computed, ref } from "vue";
import { AlertModule } from "@/store/modules/Alert";
import { iInvalidSubmit } from "@/composables/vee-validate";
import { Form, FormActions, Field } from "vee-validate";
import { PhoneFilled, Briefcase, Comment } from "@element-plus/icons";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import { dialerApi } from "@/conection/index";
import { env } from "@/config/index";
import qs from "qs";
import { formatNumber } from "@/util/utils.ts";

import * as yup from "yup";

enum sendType {
	CALL = "call",
	SMS = "sms",
	WA = "wha",
}
//schema


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const formkey = ref(0);
const formComponent = ref<
	| (FormActions<any> & {
			getValues: () => { [k: string]: string | undefined };
	  })
	| null
>(null);
const loadingCall = ref(false);
const loadingSMS = ref(false);
const loadingWA = ref(false);
const schema = yup.object({
	message: yup
		.string()
		.matches(
			/^[\w\s\p{P}\p{S}]+$/u,
			"Message is not valid, It should not contain accents."
		)
		.required("Message is required"),
	number1: yup.string().matches(/^\d{3,}$/, "Phone number 1 is not valid"),
});
async function onSubmit(values: any, type: string) {
	switch (type) {
		case sendType.SMS:
			sendSMS(values);
			break;
		case sendType.CALL:
			sendCall(values);
			break;
		default:
			break;
	}
}
async function sendSMS(values: any) {
	loadingSMS.value = true;
	try {
		const response = await dialerApi.post("/vonage/sms", {
			from: "EMLABS2",
			to: values.number1,
			message: values.message,
		});
		if (response.status === 201) {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Message sent successfully`,
				type: "success",
			});
		} else {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Error// Message has not been sent`,
				type: "error",
			});
		}
	} catch (error) {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Error// Message has not been sent`,
			type: "error",
		});
	}

	loadingSMS.value = false;
}
async function sendCall(values: any) {
	loadingCall.value = true;
	try {
		const response = await dialerApi.post("/dialer/send/notification", {
			to: {
				number: formatNumber(values.number1),
				context: "llamada_saliente_internacional",
			},
			text: values.message,
			dtmf_options: {
				ttp: 5000,
				length: 2,
			},
			config: {
				repeat: 3,
				offsetms: 2000,
			},
		});
		if (response.status === 201) {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Call sent successfully`,
				type: "success",
			});
		} else {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Error// Call has not been sent`,
				type: "error",
			});
		}
	} catch (error) {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Error// Call has not been sent`,
			type: "error",
		});
	}

	loadingCall.value = false;
}
function onInvalidSubmit(values: iInvalidSubmit) {
	console.log(values);

	const errMsgs: string[] = Object.keys(values.errors);

	AlertModule.SOCKET_PUSH_NOTIFICATION({
		text: `Please Check ${errMsgs.join()}`,
		type: "error",
	});
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_card, { "header-classes": "bg-transparent" }, {
            header: _withCtx(() => [
              _hoisted_4
            ]),
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_unref(Form), {
                class: "w-100 form-inline",
                ref_key: "formComponent",
                ref: formComponent,
                key: formkey.value,
                "validation-schema": _unref(schema),
                onInvalidSubmit: onInvalidSubmit
              }, {
                default: _withCtx(({ handleSubmit, values }) => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(BaseInput, {
                        type: "textarea",
                        name: "message",
                        label: "Message",
                        placeholder: "Hello !",
                        "label-classes": "text-muted h5 font-weight-normal mr-3",
                        alternative: "",
                        inputGroupClasses: "w-75"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(BaseInput, {
                        name: "number1",
                        label: "Phone number 1",
                        placeholder: "22505555",
                        "label-classes": "text-muted h5 font-weight-normal mr-3",
                        "addon-left-icon": "fas fa-phone",
                        inputGroupClasses: "w-75",
                        alternative: ""
                      }, {
                        infoBlock: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_base_button, {
                          disabled: loadingCall.value,
                          "native-type": "submit",
                          onClickCapture: ($event: any) => (
												handleSubmit($event, onSubmit(values, sendType.CALL))
											)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_12, [
                              (!loadingCall.value)
                                ? (_openBlock(), _createBlock(_component_el_icon, {
                                    key: 0,
                                    size: 20,
                                    color: "#FFFFF",
                                    class: "no-inherit"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(PhoneFilled))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (loadingCall.value)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                                : _createCommentVNode("", true),
                              _hoisted_14
                            ])
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClickCapture"]),
                        _createVNode(_component_base_button, {
                          type: "warning",
                          disabled: loadingSMS.value,
                          onClickCapture: ($event: any) => (
												handleSubmit($event, onSubmit(values, sendType.SMS))
											)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_15, [
                              (!loadingSMS.value)
                                ? (_openBlock(), _createBlock(_component_el_icon, {
                                    key: 0,
                                    size: 20,
                                    color: "#FFFFF",
                                    class: "no-inherit"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Comment))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (loadingSMS.value)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                                : _createCommentVNode("", true),
                              _hoisted_17
                            ])
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClickCapture"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema"]))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})